import React from 'react';
import {
  Box,
  Grid,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import SwipeableViews from 'react-swipeable-views';
import DemocracyIcon from '@mui/icons-material/Gavel';
import RelationshipsIcon from '@mui/icons-material/Handshake';
import MentalHealthIcon from '@mui/icons-material/Psychology';
import FinanceIcon from '@mui/icons-material/AttachMoney';

const items = [
  {
    icon: <DemocracyIcon />,
    title: 'Democracy',
    desc: 'Influence by misleading political content.',
    bg: '#233D60',
  },
  {
    icon: <RelationshipsIcon />,
    title: 'Relationships',
    desc: 'Tension from misinformation-fueled arguments.',
    bg: '#554779',
  },
  {
    icon: <MentalHealthIcon />,
    title: 'Mental Health',
    desc: 'Anxiety from consuming false, alarming stories.',
    bg: '#2E776D',
  },
  {
    icon: <FinanceIcon />,
    title: 'Financial Impact',
    desc: 'Scams and misleading ads cause losses.',
    bg: '#55A27E',
  },
];

const CardContent = ({ item }) => (
  <Box
    sx={{
      maxWidth: 200,
      minHeight: 160,
      mx: 'auto',
      backgroundColor: 'white',
      borderRadius: 2,
      boxShadow: 3,
      p: 3,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Box
      sx={{
        backgroundColor: item.bg,
        borderRadius: '12px',
        width: 64,
        height: 64,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        mb: 2,
      }}
    >
      {React.cloneElement(item.icon, {
        sx: { fontSize: 32, color: 'white' },
      })}
    </Box>
    <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mb: 1 }}>
      {item.title}
    </Typography>
    <Typography variant="body2" sx={{ color: '#555', textAlign: 'center' }}>
      {item.desc}
    </Typography>
  </Box>
);

const ImpactSection = () => {
  const theme = useTheme();
  const isTooNarrow = useMediaQuery('(max-width:1000px)'); // <1000px → swipe view

  return (
    <Box
      sx={{
        backgroundColor: 'rgba(244, 244, 244, 0.8)',
        px: { xs: 3, md: 6 },
        py: 3,
        mt: { xs: 8, md: 4 },
        mb: { xs: 6, md: 4 },
        mx: 'auto',
        position: 'relative',
        zIndex: 10,
        textAlign: 'center',
        borderRadius: 2,
        boxShadow: 3,
        width: '90%',
        maxWidth: '1100px',
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 3 }}>
        How Does Misinformation Affect You?
      </Typography>

      {isTooNarrow ? (
        <SwipeableViews enableMouseEvents resistance>
          {items.map((item, index) => (
            <Box key={index} sx={{ px: 2 }}>
              <CardContent item={item} />
            </Box>
          ))}
        </SwipeableViews>
      ) : (
        <Grid container spacing={4} justifyContent="center">
          {items.map((item, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <CardContent item={item} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default ImpactSection;
